import { PipeTransform } from '@angular/core';
var MainCoveragesPipe = /** @class */ (function () {
    function MainCoveragesPipe() {
    }
    MainCoveragesPipe.prototype.transform = function (items, mainIds) {
        if (!mainIds) {
            mainIds = ['C1', 'C2'];
        }
        return items.filter(function (item) { return mainIds.indexOf(item.id) > -1; });
    };
    return MainCoveragesPipe;
}());
export { MainCoveragesPipe };
